import React from 'react';
import './style.scss';

const Empty = ({ text }) => (
  <div className='column sm-12 title-lg mobile-title-lg text-center'>{text}</div>
);

export default Empty;
